(function () {
  'use strict';
  const fields = ['title', 'product_type', 'vendor', 'variants.title', 'variants.sku', 'variants.barcode'];
  const stopWords = new Set(['a', 'au', 'aux', 'de', 'des', 'du', 'd', 'en', 'et', 'la', 'le', 'les', 'pour', 'un', 'une']);
  function words(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      .match(/[\p{L}\p{N}]+(?:[-+.][\p{L}\p{N}]+)*/gu) || [];
  }
  function tokens(text) {
    const all = words(text);
    const meaningful = all.filter(word => !stopWords.has(word));
    return meaningful.length ? meaningful : all;
  }
  function decode(query) {
    if (!query.startsWith('(title:"')) return query;
    return query.split(') AND (').map(group => group.split('title:"')[1]?.split('"')[0] || '').join(' ');
  }
  function scope(query) {
    return tokens(decode(query)).map(word => '(' + fields.map(field => field + ':"' + word + '"').join(' OR ') + ')').join(' AND ');
  }
  function oneEdit(a, b) {
    if (Math.abs(a.length - b.length) > 1 || a.slice(0, 4) !== b.slice(0, 4)) return false;
    let i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (a.length >= b.length) i++;
      if (b.length >= a.length) j++;
    }
    return edits + (i < a.length || j < b.length ? 1 : 0) <= 1;
  }
  function matches(query, identity) {
    const candidates = words(identity);
    return tokens(query).every(term => candidates.some(word => word.startsWith(term) || oneEdit(term, word)));
  }
  window.otecProductSearch = { scope, decode, matches };
  const searchPath = window.otecSearchPath;
  if (!searchPath) return;
  const current = new URL(window.location.href);
  if (current.pathname === searchPath && current.searchParams.get('q')) {
    const scoped = scope(current.searchParams.get('q'));
    if (scoped && (current.searchParams.get('q') !== scoped || current.searchParams.get('type') !== 'product')) {
      current.searchParams.set('q', scoped);
      current.searchParams.set('type', 'product');
      window.location.replace(current.href);
      return;
    }
  }
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || new URL(form.action).pathname !== searchPath) return;
    const query = scope(input.value);
    if (!query) { event.preventDefault(); return; }
    event.preventDefault();
    const url = new URL(form.action);
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    window.location.assign(url.href);
  });
})();
